'use client';

import { CHANNEL_META, PhoneIcon, EmailIcon } from './ChannelIcons';

const contactRows = [
  {
    key: 'phone',
    Icon: PhoneIcon,
    accent: '#10B981',
    chipBg: '#ECFDF5',
    value: '+1 (415) 555-0134',
  },
  {
    key: 'email',
    Icon: EmailIcon,
    accent: '#F97316',
    chipBg: '#FFF7ED',
    value: 'yourteam@inbound.apprendo.co',
  },
];

export default function TessaIdentitySection() {
  return (
    <section className="py-20">
      <div className="max-w-[1200px] mx-auto px-8">
        <div className="text-center mb-13">
          <div className="landing-section-label">Meet Tessa</div>
          <h2 className="text-[38px] font-bold tracking-[-1.5px] mb-3.5 text-foreground">
            She&rsquo;s a team member, not a form.
          </h2>
          <p className="text-[17px] text-muted-foreground max-w-[540px] mx-auto">
            Tessa has her own phone number and her own inbox. Your team can call her back, text
            her, WhatsApp her, email her, or DM her on Slack — in English, Spanish, or French —
            and she remembers every conversation, so the tenth check-in feels like the tenth, not
            the first.
          </p>
        </div>

        {/* Business-card style contact card (illustrative example data) */}
        <div className="relative w-full max-w-md mx-auto bg-card border border-border rounded-2xl shadow-lg p-6">
          <span className="absolute top-4 right-5 text-[10px] uppercase tracking-[1.5px] text-muted-foreground font-space-mono">
            Example
          </span>

          <div className="flex items-center gap-4 mb-6">
            <div className="relative w-12 h-12 rounded-full overflow-hidden flex-shrink-0">
              <div
                className="absolute -inset-1"
                style={{
                  background: 'conic-gradient(from 0deg, #EF4444, #8B5CF6, #3B82F6, #EF4444)',
                  filter: 'blur(4px)',
                }}
              />
            </div>
            <div className="min-w-0">
              <div className="text-[17px] font-bold text-foreground leading-tight">Tessa</div>
              <div className="text-[13px] text-muted-foreground">Check-ins · your company</div>
            </div>
          </div>

          <div className="space-y-3">
            {contactRows.map(({ key, Icon, accent, chipBg, value }) => (
              <div key={key} className="flex items-center gap-3">
                <span
                  className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0"
                  style={{ background: chipBg, color: accent }}
                >
                  <Icon className="w-4 h-4" />
                </span>
                <span className="font-space-mono text-[14px] text-foreground truncate">
                  {value}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* The 5 channel chips */}
        <div className="flex flex-wrap items-center justify-center gap-2.5 mt-8">
          {CHANNEL_META.map(({ key, label, Icon, accent, chipBg }) => (
            <span
              key={key}
              className="inline-flex items-center gap-2 bg-card border border-border rounded-full pl-1.5 pr-3.5 py-1.5"
            >
              <span
                className="w-7 h-7 rounded-full flex items-center justify-center"
                style={{ background: chipBg, color: accent }}
              >
                <Icon className="w-4 h-4" />
              </span>
              <span className="text-[13px] font-semibold text-foreground">{label}</span>
            </span>
          ))}
        </div>

        {/* Multi-country footer */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-4">
          <p className="text-[14px] text-muted-foreground max-w-[520px] text-center sm:text-left">
            Tessa gets her own North American number the moment your workspace needs one —
            automatically, nothing to configure. On a paid plan, add a second number and pick
            its country. Need local presence elsewhere?
          </p>
          <a
            href="mailto:hello@apprendo.io"
            className="inline-flex items-center justify-center px-5 py-2 rounded-full border border-border text-[13px] font-semibold text-foreground hover:bg-muted transition-colors whitespace-nowrap flex-shrink-0"
          >
            Talk to sales
          </a>
        </div>
      </div>
    </section>
  );
}
